import AppleLogo from './AppleLogo';

export default AppleLogo;
